import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FloatingArrow } from '@floating-ui/react';
import { Card } from '../card';
import { theme } from '../theme';
import { cardStaticStyle } from './styles';
function Content({ arrowRef, children, context, hasRightDecor, highlightVariant, size, variant, }) {
    // If an arrowRef is not provided, we know not to show the arrow
    const showArrow = !(arrowRef == null);
    return (_jsxs(_Fragment, { children: [_jsx(Card, Object.assign({ as: "div", css: cardStaticStyle, "data-testid": "popover-content", disableHoverEffect: true, size: size }, (variant === 'highlight' && {
                highlightPlacement: hasRightDecor ? 'right' : 'left',
                highlightVariant,
                variant,
            }), { children: children })), showArrow && (_jsx(FloatingArrow, { context: context, "data-testid": "popover-arrow", fill: theme.background.contrast, height: 14, ref: arrowRef, stroke: theme.border.main, strokeWidth: 1, tipRadius: 2, width: 24 }))] }));
}
export default Content;
